import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { injectable } from '@servicetitan/react-ioc';
import { AgreementStatus, CustomerPortalServiceAgreements } from './portal-service-agreements.api';

@injectable()
export class ServiceAgreementsApi {
    private client: CustomerPortalServiceAgreements;
    constructor() {
        this.client = new CustomerPortalServiceAgreements(
            createMainAppMicroserviceInstance(
                '/v1/customerportal/service-agreements',
                '/api/cp/service-agreements'
            )
        );
    }

    async serviceAgreementsExist(statuses: AgreementStatus[]): Promise<boolean> {
        const response = await this.client.serviceAgreementsExist(statuses);
        return response.data;
    }
}
